import { Box, IconButton, ListItemText, Tooltip } from '@mui/material';
// material-ui
import { useTheme } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import { useGetMenuMaster } from '~/api/menu';
import AdminProfileIcon from '~/assets/images/adminprofile.svg';
import LogoutIcon from '~/assets/images/logout.svg';
// project import
import useAuth from '~/hooks/useAuth';
import PermCheck from '~/utils/PermCheck';
import { RolePolicy } from '~/utils/roles';

const LogoutIconComponent = () => {
  const theme = useTheme();
  return (
    <img
      src={LogoutIcon}
      alt="logout"
      style={{
        filter: theme.palette.mode === 'dark' ? 'invert(1)' : 'none',
      }}
    />
  );
};

const AdminProfileIconComponent = () => {
  const theme = useTheme();
  return (
    <img
      src={AdminProfileIcon}
      alt="logout"
      style={{
        filter: theme.palette.mode === 'dark' ? 'invert(1)' : 'none',
      }}
    />
  );
};

// ==============================|| DRAWER - USER ||============================== //

const NavUser = () => {
  const theme = useTheme();
  const navigate = useNavigate();

  const { menuMaster } = useGetMenuMaster();
  const drawerOpen = menuMaster.isDashboardDrawerOpened;

  const { logout, user } = useAuth();
  const handleLogout = async () => {
    try {
      await logout();
      navigate(`/login`, {
        state: {
          from: '',
        },
      });
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <Box
      sx={{
        p: 1.25,
        pl: drawerOpen ? 2.25 : 1.25,
        pr: drawerOpen ? 1.75 : 1.25,
        borderTop: `2px solid ${theme.palette.divider}`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: drawerOpen ? 'space-between' : 'center',
        background: theme.palette.mode === 'dark' ? '#343434' : theme.palette.grey[100],
        borderRadius: '0px 0px 0px 8px',
      }}
    >
      {drawerOpen ? (
        <>
          {/* Admin Profile Button */}
          <PermCheck permissions={RolePolicy.AdminProfilePage}>
            <Tooltip title="Admin Profile">
              <IconButton onClick={() => navigate('/dashboard/admin/profile/details')}>
                <AdminProfileIconComponent />
              </IconButton>
            </Tooltip>
          </PermCheck>

          {/* User's Name */}
          <ListItemText
            primary={`${user?.firstName} ${user?.lastName}`}
            sx={{
              ml: '8px',
              fontWeight: '500',
              fontSize: '0.875rem',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
          />

          {/* Logout Icon */}
          <Tooltip title="Logout" placement="top" arrow>
            <IconButton onClick={handleLogout}>
              <LogoutIconComponent />
            </IconButton>
          </Tooltip>
        </>
      ) : (
        // When collapsed, show only logout button
        <Tooltip title="Logout" placement="right" arrow>
          <IconButton onClick={handleLogout}>
            <LogoutIconComponent />
          </IconButton>
        </Tooltip>
      )}
    </Box>
  );
};

export default NavUser;
